import * as React from 'react';
import { connect } from 'react-redux';
import { Grid, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { StyledComponentProps } from '@material-ui/core/styles';
import { IMediaQueryProps, WithMediaQuery } from '../../../../layout/withMediaQuery';
import { IApplicationState } from '../../../../store/ApplicationState';
// import { IState as IMedicalExaminationState } from '../../../../common/store/medicalExaminations/state';
// import { IActions as IMedicalExaminationActions, actionCreator as medicalExaminationActions } from '../../../../common/store/medicalExaminations/actions/creators';
import { IState as ISubscriptionState } from '../../../../common/store/subscriptions/state';
import { IActions as ISubscriptionsActions, actionCreator as subscriptionsActions } from '../../../../common/store/subscriptions/actions/creators';
import { IActions as IMedicalExaminationActions, actionCreator as medicalExaminationActions } from '../../../../common/store/medicalExaminations/actions/creators';
import SaveButton from '../../../../ui-components/Button/SaveButton';
import CancelButton from '../../../../ui-components/Button/CancelButton';
import { contactInsurance, contactMedicalExamination, contactSubscription } from '../../../../model/contactsubscription';
import moment from 'moment';
import TextField from '../../../../ui-components/TextField/TextField';
import DatePicker from '../../../../ui-components/DatePicker/DatePicker';
import DeleteButton from '../../../../ui-components/Button/DeleteButton';
import { SUBSCRIPTIONTYPES } from '../../../../model/subscription';
import RemoveSingleAccessIconButton from '../../../../ui-components/Button/RemoveSingleAccessIconButton';
import { DeleteX } from '../../../drafts/components/DeleteButton';
import { useState } from 'react';
import { medicalExamination } from '../../../../model/medicalexamination';
import MedicalExaminationDocument from './MedicalExaminationDocument';


interface IProps extends IMediaQueryProps, ISubscriptionsActions, ISubscriptionState, IMedicalExaminationActions, IInnerProps {
    // IMedicalExaminationState, IMedicalExaminationActions,
}

interface IInnerProps extends StyledComponentProps {
    onCancel: () => any;
    onUpdateSubscription: (item: contactSubscription) => any;
    onRemoveSingleAccess: (item: contactSubscription) => any;
    onDeleteSubscription: (item: contactSubscription) => any;
    onUpdateMedicalExamination: (item: contactMedicalExamination) => any;
    onDeleteMedical: (item: contactMedicalExamination) => any;
    onUpdateInsurance: (item: contactInsurance) => any;
    onDeleteInsurance: (item: contactInsurance) => any;
    open: boolean;
    subscription: any;
    userId: string;
}

export const UpdateSubscriptionDialog = (props: IProps) => {

    const { subscription } = props;

    const [medicalExaminationDocument, setMedicalExaminationDocument] = useState<medicalExamination>(null);

    const [notes, setNotes] = useState<string>(subscription?.notes);
    const [accessesExtra, setAccessesExtra] = useState<number>(subscription?.accessExtra);
    const [daysExtra, setDaysExtra] = useState<number>(subscription?.daysExtra);
    const [validFrom, setValidFrom] = useState<Date>(subscription?.validFrom);
    // moment(new Date()).add(12, 'M').toDate()
    const [expiresOn, setExpiresOn] = useState<Date>(subscription?.expiresOn);
    const [monthsBuyed, setMonthsBuyed] = useState<number>(0);

    // const [subscriptionType, setSubscriptionType] = React.useState<SelectItem>({ name: 'Mensile', value: 'MENSILE' });
    // const [subscriptionType, setSubscriptionType] = React.useState<string>();

    React.useEffect(() => {
        changeExpireDate(validFrom);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [daysExtra])

    // React.useEffect(() => {
    //     changeExpireDate(validFrom);
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [daysExtra])

    const changeExpireDate = (newValidFrom: Date) => {
        let mesi = 12;
        if (monthsBuyed > 0) {
            mesi = monthsBuyed;
        }
        let fine = moment(newValidFrom).add(mesi, 'M').add(daysExtra, 'd').toDate();
        setExpiresOn(fine);
        setValidFrom(newValidFrom);
    }

    const changeValidFromDate = (newExpireDate: Date) => {
        let mesi = 12;
        if (monthsBuyed > 0) {
            mesi = monthsBuyed;
        }
        let inizio = moment(newExpireDate).subtract(mesi, 'M').subtract(daysExtra, 'd').toDate();
        setExpiresOn(newExpireDate);
        setValidFrom(inizio);
    }

    const isSubscription = (passedType: any): boolean => {
        // console.log("comparer Type:", passedType)
        if (subscription !== null) {
            // console.log("isSubscription Type:", subscription.subscription?.subscriptionType)
            // console.log("subscriptionTimestamp:", "subscriptionTimestamp" in subscription)
            // console.log("comparer Type2:", subscription?.subscription?.subscriptionType === type)
            return ("subscriptionTimestamp" in subscription
                && subscription?.subscription?.subscriptionType === passedType ? true : false);
        }
        return false;
    }

    const isInsurance = (): boolean => {
        return (subscription !== null && "insuranceTimestamp" in subscription ? true : false);
    }

    const isMedical = (): boolean => {
        return (subscription !== null && "medicalExaminationTimestamp" in subscription ? true : false);
    }

    React.useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        console.log("---------------------------------------> use effect change subsription props:", subscription)
        if (subscription !== null) {
            // console.log("------------------------------------------------- ", subscription)
            setNotes(subscription.notes);
            setValidFrom(subscription.validFrom);
            setExpiresOn(subscription.expiresOn);
            // console.log("------------------------------------------------- is subscription:", ("subscriptionTimestamp" in subscription ? true : false))
            // console.log("------------------------------------------------- is insurance:", ("insuranceTimestamp" in subscription ? true : false))
            // console.log("------------------------------------------------- is medicalexam:", ("medicalExaminationTimestamp" in subscription ? true : false))

            if ("subscriptionTimestamp" in subscription === true) {
                if (subscription.subscription?.subscriptionType === SUBSCRIPTIONTYPES.MENSILE.code) {
                    setMonthsBuyed(subscription?.subscription?.monthToBuy);
                    if (subscription.daysExtra > 0) {
                        setDaysExtra(subscription.daysExtra);
                        var d = moment(subscription.expiresOn).add(subscription.daysExtra, 'd').toDate();
                        setExpiresOn(d);
                    }
                }
                if (subscription.subscription?.subscriptionType === SUBSCRIPTIONTYPES.ACCESSI.code) {
                    setAccessesExtra(subscription.accessesExtra);
                }
            }
            else {
                setMonthsBuyed(12);
                setAccessesExtra(0);
                setDaysExtra(0);
            }
        }
    }, [subscription])

    const getSubscriptionName = () => {
        if (isSubscription(SUBSCRIPTIONTYPES.ACCESSI.code)) {
            return subscription?.subscription?.subscriptionName +
                " - Acquistati:" + subscription?.subscription?.accessToBuy + " - Consumati:" + subscription?.registeredAccess;
        }
        else {
            return subscription?.subscription?.subscriptionName;
        }
    }

    const removeaccess = async () => {
        if (isSubscription(SUBSCRIPTIONTYPES.ACCESSI.code)) {
            let end = expiresOn;
            if (daysExtra > 0) {
                end = moment(expiresOn).add(-daysExtra, 'd').toDate();
            }
            let s: contactSubscription = {
                _id: subscription._id,
                subscription: null,
                validFrom: validFrom,
                suspendedOn: null,
                expiresOn: end,
                notes: notes,
                registeredAccess: 0,
                accessesExtra: accessesExtra,
                daysExtra: daysExtra,
                subscriptionTimestamp: new Date(),
            };
            props.onRemoveSingleAccess(s);
            props.onCancel();
        }
    }

    const deleteinfo = async () => {
        // console.log("update info:", info);
        // info: {_id: '5f17754ff5ba415b7fd8049f', sub: null, cardNumber: '17069', info: 'Visita medica del 25/10/2017 scade il 10/06/2020', typof: null}
        // setEdit(true);
        if (isMedical()) {
            let m: contactMedicalExamination = {
                _id: subscription._id,
                validFrom: validFrom,
                expiresOn: expiresOn,
                notes: notes,
                medicalExaminationTimestamp: new Date(),
            };
            props.onDeleteMedical(m);
            props.onCancel();
        }
        else if (isInsurance()) {
            let i: contactInsurance = {
                _id: subscription._id,
                validFrom: validFrom,
                expiresOn: expiresOn,
                notes: notes,
                insuranceTimestamp: new Date(),
            };
            props.onDeleteInsurance(i);
            props.onCancel();
        }
        else if (isSubscription(SUBSCRIPTIONTYPES.ACCESSI.code) || isSubscription(SUBSCRIPTIONTYPES.MENSILE.code)) {
            let end = expiresOn;
            if (daysExtra > 0) {
                end = moment(expiresOn).add(-daysExtra, 'd').toDate();
            }
            let s: contactSubscription = {
                _id: subscription._id,
                subscription: null,
                validFrom: validFrom,
                suspendedOn: null,
                expiresOn: end,
                notes: notes,
                registeredAccess: 0,
                accessesExtra: accessesExtra,
                daysExtra: daysExtra,
                subscriptionTimestamp: new Date(),
                // registeredAccessDayCode
            };
            props.onDeleteSubscription(s);
            props.onCancel();
        }
    }

    const save = () => {
        // console.info("-------------------------------------------------save")
        if (isSubscription(SUBSCRIPTIONTYPES.ACCESSI.code) || isSubscription(SUBSCRIPTIONTYPES.MENSILE.code)) {
            // console.log("------------------------------------------------- is subscription:", ("subscriptionTimestamp" in subscription ? true : false))
            // remove day extra to expired on
            let end = expiresOn;
            if (daysExtra > 0) {
                end = moment(expiresOn).add(-daysExtra, 'd').toDate();
            }
            let s: contactSubscription = {
                _id: subscription._id,
                subscription: null,
                validFrom: validFrom,
                suspendedOn: null,
                expiresOn: end,
                notes: notes,
                registeredAccess: 0,
                accessesExtra: accessesExtra,
                daysExtra: daysExtra,
                subscriptionTimestamp: new Date(),
            };
            props.onUpdateSubscription(s);
        }
        if (isInsurance()) {
            // console.log("------------------------------------------------- is insurance:", ("insuranceTimestamp" in subscription ? true : false))
            let i: contactInsurance = {
                _id: subscription._id,
                validFrom: validFrom,
                expiresOn: expiresOn,
                notes: notes,
                insuranceTimestamp: new Date(),
            };
            props.onUpdateInsurance(i);
        }
        if (isMedical()) {
            console.log("------------------------------------------------- is medicalexam:", ("medicalExaminationTimestamp" in subscription ? true : false))
            // scarico SEM
            let m: contactMedicalExamination = {
                _id: subscription._id,
                validFrom: validFrom,
                expiresOn: expiresOn,
                notes: notes,
                medicalExaminationTimestamp: new Date(),
            };
            // console.log("------------------------------------------------- is medicalexam:", medicalExaminationDocument)
            // console.log("------------------------------------------------- is medicalexam:", subscription)
            // if (subscription.firebaseUri && subscription.firebaseUri !== null &&
            //     subscription.medicalExaminationDocumentId && subscription.medicalExaminationDocumentId !== null) {
            //     m.medicalExaminationDocumentId = subscription.medicalExaminationDocumentId
            //     m.firebaseUri = subscription.firebaseUri;
            // }
            if (medicalExaminationDocument === undefined || medicalExaminationDocument === null || medicalExaminationDocument.isDeleted) {
                m.medicalExaminationDocumentId = null;
                m.firebaseUri = null;
            }
            else if (medicalExaminationDocument) {
                m.medicalExaminationDocumentId = medicalExaminationDocument._id;
                m.firebaseUri = medicalExaminationDocument.firebaseUri;
            } else {
                m.medicalExaminationDocumentId = subscription.medicalExaminationDocumentId;
                m.firebaseUri = subscription.firebaseUri;
            }
            props.onUpdateMedicalExamination(m);
            props.resetNewMedicalExamination();
        }
        props.onCancel();
    }

    const onUpdateMedicalExaminationDocument = (item: medicalExamination) => {
        console.log("onUpdateMedicalExaminationDocument function in file UpdateSubscriptionDialog medicalExamination:", item)
        setMedicalExaminationDocument(item);
    }

    var title = (isMedical() ? "Modifica Visita Medica"
        : (isSubscription(SUBSCRIPTIONTYPES.MENSILE.code) ? "Modifica Abbonamento"
            : (isSubscription(SUBSCRIPTIONTYPES.ACCESSI.code) ? "Modifica Abbonamento ad Ingressi"
                : "Modifica Iscrizione")));

    var confirmText = (isMedical() ? "Visita Medica."
        : (isSubscription(SUBSCRIPTIONTYPES.MENSILE.code) ? "Abbonamento."
            : (isSubscription(SUBSCRIPTIONTYPES.ACCESSI.code) ? "Abbonamento ad Ingressi."
                : "Iscrizione.")));

    const subscriptionTypes = Object.keys(SUBSCRIPTIONTYPES);
    //Prenotazioni di {this.getContactDescription(this.props.contact)}

    // const onFileChange = (event) => {
    //     console.log("onFileChange event:", event.target.files[0]);
    //     /*
    //     lastModified:1754641841782
    //     lastModifiedDate:Fri Aug 08 2025 10:30:41 GMT+0200 (Ora legale dell’Europa centrale) {}
    //     name:"output.pdf"
    //     size:9978
    //     type:"application/pdf"
    //     webkitRelativePath: ""
    //     */
    //     const file = event.target.files[0];
    //     setSelectedFile(file);
    //     const base64 = convertBase64(file).then(y => {
    //         console.log("onFileChange then base64:", y);
    //     });
    //     console.log("onFileChange base64:", base64);
    // };

    // const fileDelete = () => {
    //     setSelectedFile(null);
    // }

    // const convertBase64 = (file) => {
    //     return new Promise((resolve, reject) => {
    //         const fileReader = new FileReader();
    //         fileReader.readAsDataURL(file);
    // 
    //         fileReader.onload = () => {
    //             resolve(fileReader.result);
    //         };
    // 
    //         fileReader.onerror = (error) => {
    //             reject(error);
    //         };
    //     });
    // };

    // const onFileUpload = () => {
    //     if (selectedFile) {
    //         const formData = new FormData();
    //         formData.append(
    //             "myFile",
    //             selectedFile,
    //             selectedFile.name
    //         );
    //         console.log("onFileUpload selectedFile:", selectedFile);
    //         console.log("onFileUpload subscription:", props.userId);
    //         //addMedicalExamination()
    //         //axios.post("api/uploadfile", formData);
    //         const ext = selectedFile.name.slice((selectedFile.name.lastIndexOf(".") - 1 >>> 0) + 2);
    //         const b64 = convertBase64(selectedFile).then(x => {
    //             console.log("onFileUpload base64:", x);
    //         });
    //         const i = {
    //             _id: undefined,
    //             expiresOn: expiresOn,
    //             validFrom: validFrom,
    //             sub: props.userId,
    //             nome: '',
    //             cognome: '',
    //             email: '',
    //             extension: ext,
    //             firebaseUri: '',
    //             isValidateByGym: true,
    //             isDeleted: false,
    //             loadedByUser: false,
    //             medicalExaminationTimestamp: undefined,
    //             mimeType: selectedFile.type,
    //             notes: notes,
    //             originalFileName: selectedFile.name,
    //             uploadedFileName: selectedFile.name,
    //             base64: 'empty',
    //         } as medicalExamination;
    //         props.addMedicalExamination(props.userId, i);
    //     }
    // };

    // React.useEffect(() => {
    //     console.log("------------------------------------------------- isLoadingMex:", props.isLoadingMex)
    // }, [props.isLoadingMex])

    // React.useEffect(() => {
    //     console.log("------------------------------------------------- newMedicalExamination:", props.newMedicalExamination)
    // }, [props.newMedicalExamination])


    // const fileData = () => {
    //     if (selectedFile) {
    //         return (
    //             <div>
    //                 {/* <h2>File Details:</h2>
    //                 <p>File Name: {selectedFile.name}</p>
    //                 <p>File Type: {selectedFile.type}</p>
    //                 <p>Last Modified: {selectedFile.lastModifiedDate.toDateString()}</p> */}
    //                 <h4>File caricato. Proseguire con il salvataggio!</h4>
    //             </div>
    //         );
    //     } else {
    //         return (
    //             <div>
    //                 <h4>Seleziona il file con la scansione della visita medica.</h4>
    //             </div>
    //         );
    //     }
    // };

    const doCancel = () => {
        props.onCancel();
        props.resetNewMedicalExamination();
    }

    const doDelete = (e: any) => {
        // e.preventDefault();
        // if (isMedical()) {
        //     const _id = subscription?._id;
        //     props.onDeleteMedical(_id);
        // }
    }

    const getMedicalExaminationLabel = () => {
        if (isMedical()) {
            if (subscription?.firebaseUri)
                <b><a href={subscription?.firebaseUri} target='_blank' rel='noopener noreferrer'>VISITA MEDICA</a></b>
            else
                <p><b>SCANSIONE VISITA MEDICA DA CARICARE</b></p>
        }
        return <></>
    }

    return (
        <div>
            <Dialog
                open={props.open}
                onClose={doCancel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {<DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
                <DialogContent>
                    <Grid container>
                        <Grid item sm={12}>
                            <label>{subscriptionTypes.map(t => {
                                if (SUBSCRIPTIONTYPES[t].code === subscription?.subscription?.subscriptionType) {
                                    return SUBSCRIPTIONTYPES[t].title;
                                }
                                else {
                                    return "";
                                }
                            })}</label>
                            {/* isSubscription ? (
                            <Select fullWidth
                                // selected={getSubscriptionType(subscriptionType)}
                                selected={subscriptionType}
                                items={subscriptionTypes.map(t => {
                                    return { name: SUBSCRIPTIONTYPES[t].title, value: t }
                                })}
                                onChange={(item) => changeSubscriptionTypeValue(item)} label='Seleziona un tipo' />
                            ) : <></> */}
                        </Grid>
                        <Grid item xs={12} style={{ margin: "5px" }}>
                            <label>{getSubscriptionName()}</label>
                            {/* isSubscription ? (
                            <SearchBoxApi<subscription>
                                clearItem={r => ClearItemsRef.current = r}
                                //selectedItem={props.selectedSubscription === undefined ? null : props.selectedSubscription}
                                openOnFocus
                                doFilter
                                disabled={false}
                                listSize={10}
                                getItems={searchSubscriptionSearchBox}
                                label={"Abbonamento"}
                                placeholder={"Cercare abbonamento"}
                                templateItem={templateSearchBoxSubscription}
                                onSelectedChange={(item) => loadSubscription(item)}
                                minCharacterNumber={1} />
                        ) : <></> */ }
                        </Grid>
                        <Grid item sm={12}>
                            {isSubscription(SUBSCRIPTIONTYPES.MENSILE.code) ?
                                <TextField type={"number"} disabled={false}
                                    label="Numero Giorni Extra"
                                    onChange={(val) => setDaysExtra(Number(val))}
                                    value={daysExtra?.toString()}
                                />
                                : <></>}
                        </Grid>
                        <Grid item sm={12}>
                            {isSubscription(SUBSCRIPTIONTYPES.ACCESSI.code) ?
                                <TextField type={"number"} disabled={false}
                                    label="Numero Accessi Extra"
                                    onChange={(val) => setAccessesExtra(Number(val))}
                                    value={accessesExtra?.toString()}
                                />
                                : <></>}
                        </Grid>
                        <Grid item sm={12}>
                            <TextField
                                label="Note"
                                onChange={(val) => setNotes(val)}
                                value={notes}
                            />
                        </Grid>
                        <Grid item sm={12}>
                            <DatePicker
                                key={`dataInizioValidita-from-date-picker`}
                                label="Data inizio validità"
                                fullWidth
                                //minDate={new Date()}
                                value={validFrom}
                                onChange={(d) => { changeExpireDate(d); }}
                            />
                        </Grid>
                        <Grid item sm={12}>
                            <DatePicker
                                key={`dataFineValidita-from-date-picker`}
                                label="Data fine validità"
                                fullWidth
                                disabled={false}
                                minDate={new Date()}
                                value={expiresOn}
                                onChange={(d) => { changeValidFromDate(d); }}
                            />
                        </Grid>
                        <Grid item sm={12}>
                            {/* <input style={{ borderBottom: '1px solid grey', borderRight: '1px solid grey', marginRight: '2px' }} type="file" onChange={onFileChange} />
                            <button style={{ margin: '2px' }} onClick={onFileUpload}>Carica</button>
                            <button style={{ margin: '2px' }} onClick={fileDelete}>Elimina</button>
                            {fileData()} */}
                            {isMedical() ? <MedicalExaminationDocument
                                onUpdateMedicalExaminationDocument={onUpdateMedicalExaminationDocument}
                                subscription={subscription}
                                expiresOn={expiresOn}
                                validFrom={validFrom}
                                notes={notes}
                                userId={props.userId} /> : <></>}
                            {/* // expiresOn={expiresOn}
                                // validFrom={validFrom}
                                // notes={notes}
                                // firebaseUri={subscription?.firebaseUri}
                                // documentId={subscription?.medicalExaminationDocumentId}
                                // userId={props.userId} /> : <></>} */}
                            {/* <span>TEST NOT IS MEDICAL : {isMedical()} - {JSON.stringify(subscription)}</span> */}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <>
                        {isSubscription(SUBSCRIPTIONTYPES.ACCESSI.code) || isSubscription(SUBSCRIPTIONTYPES.MENSILE.code) ?
                            <>
                                <RemoveSingleAccessIconButton onClick={removeaccess} title={'Elimina 1 Accesso'} />
                                <DeleteX action={deleteinfo} text={'Eliminazione ' + confirmText + '. Sei sicuro di voler proseguire?'} />
                            </>
                            : <></>}
                        {getMedicalExaminationLabel()}
                        <SaveButton onClick={save} />
                        <CancelButton onClick={doCancel} />
                    </>
                </DialogActions>
            </Dialog >
        </div>
    );
}

const mapStateToProps = (state: IApplicationState, ownProps: any): any => {
    return {
        ...ownProps,
        ...state.subscriptions
    }
}

const mapDispatchToProps = (dispatch: any) => ({
    ...subscriptionsActions(dispatch),
    ...medicalExaminationActions(dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)((WithMediaQuery(UpdateSubscriptionDialog))) as React.ComponentType<IInnerProps>;
